import { render, staticRenderFns } from "./AddWorkflow.vue?vue&type=template&id=78e2bfd9&scoped=true"
import script from "./AddWorkflow.vue?vue&type=script&lang=js"
export * from "./AddWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e2bfd9",
  null
  
)

export default component.exports